import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./Alerts'));

function LoadableAlerts() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableAlerts;
